const cities = [
  { name: "Tucson", zips: "85701, 85704, 85705, 85710, 85711, 85712, 85713, 85716, 85718, 85719, 85730, 85741, 85745, 85747, 85748, 85749, 85750" },
  { name: "Marana", zips: "85653, 85658, 85742, 85743" },
  { name: "Oro Valley", zips: "85704, 85737, 85755" },
  { name: "Sahuarita / Green Valley", zips: "85614, 85629" },
  { name: "Vail / Rita Ranch", zips: "85641" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from your UA-area apartment, Foothills home, or Marana office in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping from any UPS or FedEx location in Tucson. We handle every detail from there — no need to drive to Phoenix or Los Angeles.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and prevent delays for your PCS orders, study-abroad program, or research trip.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed. No 120-mile drive to Phoenix.",
  },
];

export default function TucsonLocalAreaSection() {
  return (
    <section id="service-area" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Tucson &amp; Southern Arizona
          </h2>
        </div>

        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-[#F7F8FA] rounded-lg p-8 md:p-10 border border-gray-200">
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Tucson is a city of surprising complexity. Most Americans think of it as a retirement destination and border town — which it is — but Tucson is also Arizona's second-largest city, home to one of the most respected research universities in the country, two major military installations, and a defense and aerospace industry that ranks among the most significant in the American Southwest. That combination generates a passport demand that is both large in volume and intensely time-sensitive.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              The University of Arizona sends thousands of students abroad each academic year — study-abroad semesters in Spain, Germany, France, and Japan; research expeditions to Latin America and Africa; and graduate fieldwork in locations that require current passports. Most UA students applying for their first passport discover the process only after receiving program acceptance letters, which often arrive 60 to 90 days before departure. Standard post office processing frequently cannot meet that window, and first-time applicants face an in-person acceptance clerk step that adds additional complexity.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Davis-Monthan Air Force Base and Raytheon Missiles & Defense are two of Tucson's largest employers and two of its most time-sensitive passport generators. PCS orders from Davis-Monthan often arrive with 30 days or less to report to assignments in South Korea, Germany, or Japan. Dependent passports must be current. Raytheon engineers and program managers travel to international defense partners and government clients on short notice — contracts do not accommodate passport processing backlogs.
            </p>
            <p className="text-gray-600 text-base leading-[1.8]">
              Fast Passport Center was built for exactly these situations. We provide Tucson residents — from the University District to the Foothills to Marana — with the expedited, professional passport service their timelines demand. No driving to the Phoenix Passport Agency 120 miles away. No waiting for government appointments that may not open. Just reliable, predictable service from a registered U.S. Department of State courier.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-passport-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Tucson, AZ</p>
                  <p className="text-white/60 text-xs mt-0.5">Serving Southern Arizona Remotely</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Remote service — no local office visit required
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Serving Tucson, Marana, Oro Valley, Sahuarita &amp; Green Valley</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, <strong className="text-white">ship your documents overnight</strong> from any UPS or FedEx location in Tucson. Most clients ship from home — no office visit required. The nearest passport agency (Phoenix) is about 120 miles away. We eliminate that trip entirely.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-[#F7F8FA] rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="bg-[#F7F8FA] rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div key={i} className="flex items-center justify-between py-2.5 px-3 bg-white rounded-md">
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono hidden sm:inline">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in Southern Arizona — start online, ship overnight, and we handle the rest. No need to drive 120 miles to the Phoenix Passport Agency.
              </p>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Nearby Cities We Serve</p>
                <div className="flex flex-wrap gap-2">
                  {[
                    { name: "Phoenix", href: "/cities/phoenix" },
                    { name: "Marana", href: "/cities/marana" },
                    { name: "Oro Valley", href: "/cities/oro-valley" },
                    { name: "Green Valley", href: "/cities/green-valley" },
                    { name: "Nogales", href: "/cities/nogales" },
                    { name: "Scottsdale", href: "/cities/scottsdale" },
                  ].map((link) => (
                    <a
                      key={link.href}
                      href={link.href}
                      className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-white border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                    >
                      {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Tucson Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}